import { useTranslation } from "react-i18next";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { HalfPriceRulesPanel } from "./HalfPriceRulesPanel";

interface Props {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  /** Ajusta o texto do rodapé conforme quem está lendo. */
  audience?: "producer" | "buyer";
}

export function HalfPriceRulesModal({ open, onOpenChange, audience = "producer" }: Props) {
  const { t } = useTranslation('producerEventForm');

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-5xl p-0 overflow-hidden">
        <div className="px-6 pt-5 pb-3.5 border-b border-border/50">
          <h2 className="text-lg font-bold tracking-tight text-foreground">{t("halfPrice.titulo")}</h2>
          <p className="text-sm text-muted-foreground mt-0.5">
            {t("halfPrice.descricao")}
          </p>
        </div>

        <HalfPriceRulesPanel audience={audience} variant="wide" />

        <div className="px-6 py-3 border-t border-border/50 flex items-center justify-between gap-3">
          <p className="text-[11px] text-muted-foreground">{t("halfPrice.acceptedDocsFooter")}</p>
          <button
            type="button"
            onClick={() => onOpenChange(false)}
            className="rounded-xl h-10 px-5 text-sm font-medium bg-primary text-primary-foreground shrink-0 hover:bg-primary/90 transition-[background-color,transform] duration-150 ease-out active:scale-[0.97]"
          >
            {t("halfPrice.botaoEntendi")}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
